// extracted by mini-css-extract-plugin
var _1 = "#68914d";
var _2 = "#9cc681";
var _3 = "#8ab46f";
var _4 = "8px";
var _5 = "6px";
var _6 = "8px";
var _7 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _8 = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _9 = "10px";
var _a = "#e8e8e8";
var _b = "16px 24px";
var _c = "#38aa73";
var _d = "#956c22";
var _e = "#2988bd";
var _f = "#eee";
var _10 = "#c4842d";
var _11 = "#b8567c";
var _12 = "#8b6e4e";
var _13 = "#5889c2";
var _14 = "#4e8a8a";
var _15 = "#6a8a3e";
var _16 = "#7b5ea7";
var _17 = "#4a6fa5";
var _18 = "#3a8a6e";
var _19 = "#c25b4e";
var _1a = "#fafbfc";
var _1b = "#1e3050";
var _1c = "#293d62";
var _1d = "#fafbfc";
var _1e = "rgba(0,0,0,.12)";
var _1f = "#d9d9d9";
var _20 = "rgba(5,5,5,.1)";
var _21 = "#eaf2fc";
var _22 = "rgba(0,0,0,.65)";
var _23 = "#ebebeb";
var _24 = "#068467";
var _25 = "rgba(6,132,103,.1)";
var _26 = "#dc4949";
var _27 = "rgba(220,73,73,.1)";
var _28 = "#787c81";
var _29 = "#d6d9dc";
var _2a = "#f3f5f7";
var _2b = "#73c9b2";
var _2c = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _2d = "#b8e7da";
var _2e = "#5357f8";
var _2f = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _30 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _31 = "#f7f8f9";
var _32 = "#edeeef";
var _33 = "#7b8996";
var _34 = "#ededed";
var _35 = "#f4f5f7";
var _36 = "#fbfbfc";
var _37 = "rgba(0,0,0,.75)";
var _38 = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _39 = "rgba(0,0,0,.3)";
var _3a = "rgba(0,0,0,.5)";
var _3b = "rgba(0,0,0,.4)";
var _3c = "rgba(0,0,0,.95)";
var _3d = "rgba(0,0,0,.65)";
var _3e = "rgba(0,0,0,.85)";
var _3f = "container___dIZKW";
var _40 = "20px";
var _41 = "#f41e28";
var _42 = "1063px";
var _43 = "date-range___G1EPg";
var _44 = "ds-icon___gDbtt";
var _45 = "rgba(227,89,86,.2)";
var _46 = "#e35956";
var _47 = "16px 24px";
var _48 = "28px";
var _49 = "32px";
var _4a = "18px";
var _4b = "14px";
var _4c = "14px";
var _4d = "15px";
var _4e = "12.6px";
var _4f = "11px";
var _50 = "20px";
var _51 = "28px";
var _52 = "700";
var _53 = "200";
var _54 = "300";
var _55 = "500";
var _56 = "400";
var _57 = "600";
var _58 = "hsla(0,0%,100%,.2)";
var _59 = "#ccc";
var _5a = "49px";
var _5b = "5px";
var _5c = "info-icon___XGdiR";
var _5d = "#5357f8";
var _5e = "rgba(0,0,0,.4)";
var _5f = "metadata___hPPmt";
var _60 = "org-logo___Tzg_M";
var _61 = "org-name___lw49y";
var _62 = "page-break___YKBW0";
var _63 = "#fafafa";
var _64 = "hsla(0,0%,100%,.9)";
var _65 = "powered___XcogC";
var _66 = "15px";
var _67 = "20px";
var _68 = "24px";
var _69 = "hsla(0,0%,100%,.6)";
var _6a = "#7e7eff";
var _6b = "hsla(0,0%,100%,.7)";
var _6c = "hsla(0,0%,100%,.3)";
var _6d = "hsla(0,0%,100%,.575)";
var _6e = "60px";
var _6f = "208px";
var _70 = "rgba(82,196,26,.2)";
var _71 = "#52c41a";
var _72 = "tab-content___GdlYy";
var _73 = "tab-header___jBH21";
var _74 = "tab-section___v7oqa";
var _75 = "table___WhzN_";
var _76 = "12px";
var _77 = "20px";
var _78 = "rgba(250,173,20,.2)";
var _79 = "#faad14";
var _7a = "#fff";
var _7b = "hsla(0,0%,100%,.2)";
var _7c = "widget___p12Lh";
export { _1 as "actionButtonColorDark", _2 as "actionButtonColorLight", _3 as "actionButtonColorMedium", _4 as "borderRadiusCard", _5 as "borderRadiusMain", _6 as "borderRadiusSurface", _7 as "boxShadowInnerXs", _8 as "boxShadowXl", _9 as "btnRightMargin", _a as "cardBorderColor", _b as "cardPadding", _c as "changeSetCompletedColor", _d as "changeSetManuallyChangesProposed", _e as "changeSetScheduledChangesProposed", _f as "chipBackground", _10 as "colorAccentAmber", _11 as "colorAccentBerry", _12 as "colorAccentBrown", _13 as "colorAccentCornflower", _14 as "colorAccentCyan", _15 as "colorAccentOlive", _16 as "colorAccentPurple", _17 as "colorAccentSteelBlue", _18 as "colorAccentTeal", _19 as "colorAccentTerracotta", _1a as "colorBackgroundMain", _1b as "colorBackgroundSidebar", _1c as "colorBackgroundSidebarHover", _1d as "colorBackgroundTabs", _1e as "colorBorderContainer", _1f as "colorBorderMain", _20 as "colorBorderSecondary", _21 as "colorDeltaCyanBlueBg", _22 as "colorDeltaGray", _23 as "colorDeltaGrayBg", _24 as "colorDeltaGreen", _25 as "colorDeltaGreenBg", _26 as "colorDeltaRed", _27 as "colorDeltaRedBg", _28 as "colorDetailsFieldText", _29 as "colorDetailsIcon", _2a as "colorDetailsTagBg", _2b as "colorMint", _2c as "colorMintGradient", _2d as "colorMintLight", _2e as "colorPrimary", _2f as "colorPrimaryHover", _30 as "colorPrimaryLightened", _31 as "colorTableHeadBg", _32 as "colorTableHeadBgHover", _33 as "colorTableHeadSubtitle", _34 as "colorTableRowBorder", _35 as "colorTableTextBg", _36 as "colorTableTotalRowBg", _37 as "colorTextBase", _38 as "colorTextDisabled", _39 as "colorTextExtraLight", _3a as "colorTextLight", _3b as "colorTextLighter", _3c as "colorTextMainHeading", _3d as "colorTextMuted", _3e as "colorTextPrimary", _3f as "container", _40 as "contentHorizPadding", _41 as "dangerColor", _42 as "dashboardPdfContentWidth", _43 as "date-range", _44 as "ds-icon", _45 as "errorBackcolor", _46 as "errorColor", _47 as "filterPanelPadding", _48 as "filtersDefaultHeight", _49 as "filtersTallHeight", _4a as "fontSizeLarge", _4b as "fontSizeMain", _4c as "fontSizeMedium", _4d as "fontSizePlus", _4e as "fontSizeSmaller", _4f as "fontSizeSmallest", _50 as "fontSizeXLarge", _51 as "fontSizeXxLarge", _52 as "fontWeightBold", _53 as "fontWeightExtraLight", _54 as "fontWeightLight", _55 as "fontWeightMediumBold", _56 as "fontWeightNormal", _57 as "fontWeightSemiBold", _58 as "ghostWhite", _59 as "grayBackgroundColor", _5a as "headerHeight", _5b as "iconHorizontalMargin", _5c as "info-icon", _5d as "linkColor", _5e as "linkColorMuted", _5f as "metadata", _60 as "org-logo", _61 as "org-name", _62 as "page-break", _63 as "popoverHeaderColor", _64 as "popoverMaskColor", _65 as "powered", _66 as "rowPadding", _67 as "ruleInnerGutters", _68 as "ruleSideGutters", _69 as "sideMenuIconColor", _6a as "sideMenuIconSelectedColor", _6b as "sideMenuItemColor", _6c as "sideMenuScrollbarThumbColor", _6d as "sideMenuSubmenuItemColor", _6e as "sidebarCollapsedWidth", _6f as "sidebarWidth", _70 as "successBackcolor", _71 as "successColor", _72 as "tab-content", _73 as "tab-header", _74 as "tab-section", _75 as "table", _76 as "tableHeaderVerticalPadding", _77 as "tableHorizPadding", _78 as "warningBackcolor", _79 as "warningColor", _7a as "whiteColor", _7b as "whiteDividerColor", _7c as "widget" }
